import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router'

import { yupResolver } from '@hookform/resolvers/yup'
import { SignupPageStatus } from '@ui/interfaces'
import { useAuth } from '@ui/providers/AuthProvider'
import cx from 'clsx'
import * as Yup from 'yup'

type LoginFormProps = {
  setPageStatus: (status: SignupPageStatus) => void
  setMessage: (message: string) => void
}

export function ForgotForm(props: LoginFormProps) {
  const { setPageStatus, setMessage } = props
  const auth = useAuth()

  const [waiting, setWaiting] = useState(false)

  const schema = Yup.object({
    email: Yup.string().email().required('Email required'),
  })

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const sendToServer = ({ email }: { email: string }) => {
    setWaiting(true)
    auth.resetPassword(email, (error) => {
      setWaiting(false)
      if (error) {
        setError('email', { message: 'Invalid email or password' })
      } else {
        setMessage('Check your email for a reset link')
        setPageStatus(SignupPageStatus.SUCCESS)
      }
    })
  }
  return (
    <div className={'h-fit w-full py-8'}>
      <form onSubmit={handleSubmit(sendToServer)} className="space-y-2 text-left">
        <div>
          <label htmlFor="email" className="text-sm text-gray-700">
            Email
          </label>
          <input
            {...register('email')}
            type="text"
            name="email"
            id="email"
            className="block w-full rounded-md border-0 bg-white text-gray-600 shadow-sm outline-none ring-2 ring-inset ring-gray-200 transition-all duration-300 ease-in-out placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-200 sm:text-sm sm:leading-6"
            placeholder="name@company.com"
          />
          {errors.email && <p className="mt-2 text-xs italic text-red-500">{errors.email?.message}</p>}
        </div>
        <button
          type="submit"
          disabled={waiting}
          className={cx(
            waiting ? 'bg-primary-100' : 'bg-primary-500',
            'w-full rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm transition-colors duration-300 ease-in-out hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600'
          )}>
          {waiting ? 'Sending...' : 'Send reset email'}
        </button>

        <div className="flex flex-col items-center text-sm">
          <div className="pb-2">
            Need an account?{' '}
            <Link
              to="/signup"
              key="signup"
              onClick={() => setPageStatus(SignupPageStatus.SIGNUP)}
              className="text-primary-500">
              Signup
            </Link>
          </div>
          <div>
            Have an account?
            <Link to="/login" className="pl-1 text-primary-500">
              Login
            </Link>
          </div>
        </div>
      </form>
    </div>
  )
}
